"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Aggregate = void 0;
var _stringify = require("../../../common/util/stringify");
var _harvestScheduler = require("../../../common/harvest/harvest-scheduler");
var _cleanUrl = require("../../../common/url/clean-url");
var _info = require("../../../common/config/info");
var _init = require("../../../common/config/init");
var _runtime = require("../../../common/config/runtime");
var _constants = require("../constants");
var _runtime2 = require("../../../common/constants/runtime");
var _aggregateBase = require("../../utils/aggregate-base");
var _console = require("../../../common/util/console");
var _now = require("../../../common/timing/now");
var _registerHandler = require("../../../common/event-emitter/register-handler");
var _drain = require("../../../common/drain/drain");
var _constants2 = require("../../metrics/constants");
var _eventBuffer = require("../../utils/event-buffer");
var _traverse = require("../../../common/util/traverse");
var _agentConstants = require("../../../common/constants/agent-constants");
/*
 * Copyright 2020 New Relic Corporation. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

class Aggregate extends _aggregateBase.AggregateBase {
  #agentRuntime;
  static featureName = _constants.FEATURE_NAME;
  constructor(agentIdentifier, aggregator) {
    super(agentIdentifier, aggregator, _constants.FEATURE_NAME);
    this.eventsPerHarvest = 1000;
    this.harvestTimeSeconds = (0, _init.getConfigurationValue)(this.agentIdentifier, 'generic_events.harvestTimeSeconds');
    this.referrerUrl = _runtime2.isBrowserScope && document.referrer ? (0, _cleanUrl.cleanURL)(document.referrer) : undefined;
    this.events = new _eventBuffer.EventBuffer();
    this.#agentRuntime = (0, _runtime.getRuntime)(this.agentIdentifier);
    this.waitForFlags(['ins']).then(([ins]) => {
      if (!ins) {
        this.blocked = true;
        (0, _drain.deregisterDrain)(this.agentIdentifier, this.featureName);
        return;
      }
      if ((0, _init.getConfigurationValue)(this.agentIdentifier, 'page_action.enabled')) {
        (0, _registerHandler.registerHandler)('api-addPageAction', (timestamp, name, attributes) => {
          this.addEvent({
            ...attributes,
            eventType: 'PageAction',
            timestamp: Math.floor(this.#agentRuntime.timeKeeper.correctAbsoluteTimestamp(this.#agentRuntime.timeKeeper.convertRelativeTimestamp(timestamp))),
            timeSinceLoad: timestamp / 1000,
            actionName: name,
            referrerUrl: this.referrerUrl,
            currentUrl: (0, _cleanUrl.cleanURL)('' + location),
            ...(_runtime2.isBrowserScope && {
              browserWidth: window.document.documentElement?.clientWidth,
              browserHeight: window.document.documentElement?.clientHeight
            })
          });
        }, this.featureName, this.ee);
      }
      this.harvestScheduler = new _harvestScheduler.HarvestScheduler('ins', {
        onFinished: (...args) => this.onHarvestFinished(...args)
      }, this);
      this.harvestScheduler.harvest.on('ins', (...args) => this.onHarvestStarted(...args));
      this.harvestScheduler.startTimer(this.harvestTimeSeconds, 0);
      this.drain();
    });
  }

  // WARNING: Insights times are in seconds. EXCEPT timestamp, which is in ms.
  addEvent(obj = {}) {
    if (!obj || !Object.keys(obj).length) return;
    if (!obj.eventType) {
      (0, _console.warn)(44);
      return;
    }
    for (let key in obj) {
      let val = obj[key];
      obj[key] = val && typeof val === 'object' ? (0, _stringify.stringify)(val) : val;
    }
    const defaultEventAttributes = {
      /** should be overridden by the event-specific attributes, but just in case -- set it to now() */
      timestamp: Math.floor(this.#agentRuntime.timeKeeper.correctAbsoluteTimestamp(this.#agentRuntime.timeKeeper.convertRelativeTimestamp((0, _now.now)()))),
      /** all generic events require a pageUrl */
      pageUrl: (0, _cleanUrl.cleanURL)((0, _runtime.getRuntime)(this.agentIdentifier).origin)
    };
    const eventAttributes = {
      /** Agent-level custom attributes */
      ...((0, _info.getInfo)(this.agentIdentifier).jsAttributes || {}),
      /** Fallbacks for required properties in-case the event did not supply them, should take precedence over agent-level custom attrs */
      ...defaultEventAttributes,
      /** Event-specific attributes take precedence over agent-level custom attributes and fallbacks */
      ...obj
    };
    this.events.add(eventAttributes);
    this.checkEventLimits();
  }
  onHarvestStarted(options) {
    const {
      userAttributes,
      atts
    } = (0, _info.getInfo)(this.agentIdentifier);
    if (!this.events.hasData) return;
    var payload = {
      qs: {
        ua: userAttributes,
        at: atts
      },
      body: (0, _traverse.applyFnToProps)({
        ins: this.events.buffer
      }, this.obfuscator.obfuscateString.bind(this.obfuscator), 'string')
    };
    if (options.retry) this.events.hold();
    return payload;
  }
  onHarvestFinished(result) {
    if (result && result?.sent && result?.retry && this.events.held.hasData) this.events.unhold();else this.events.held.clear();
  }
  checkEventLimits() {
    // check if we've reached any harvest limits...
    if (this.events.bytes > _agentConstants.IDEAL_PAYLOAD_SIZE) {
      this.ee.emit(_constants2.SUPPORTABILITY_METRIC_CHANNEL, ['GenericEvents/Harvest/Max/Seen']);
      this.harvestScheduler.runHarvest();
    }
  }
}
exports.Aggregate = Aggregate;